import React from "react";
import "./Progess.css";
import bgImage from "./parallax_homepage1x.webp";
const Progess = () => {
  return (
    <>
      <section
        className="bg-size-cover bg-attachment-fixed-lg pt-6 pb-6 js-stellar progess-section"
        style=  {{backgroundImage: `url(${bgImage})`}}
        data-stellar-background-ratio="0.5"
      >
        <div className="container  mw-960 overflow-hidden">
          <div className="row justify-content-center flex-wrap">
            <div className="w-100 row factbandblock color-white gy-3">
              <div className="col-6 col-lg-3">
                <p className="display-size-3 font-untitled-bold m-0 color-white">
                  5
                </p>
                <p className="display-size-13 display-size-13-sm font-slatepro-medium m-0 color-white">
                  YEARS OF LEADERSHIP IN ELECTRONIC TRADING
                </p>
              </div>
              <div className="col-6 col-lg-3">
                <p className="display-size-3 font-untitled-bold m-0 color-white">
                  1+
                </p>
                <p className="display-size-13 display-size-13-sm font-slatepro-medium m-0 color-white">
                  QUADRILLION USD TRADED SINCE LAUNCH
                </p>
                <p className="display-size-13 display-size-13-sm mt-2 mb-0">
                  (As of 2Q2024)
                </p>
              </div>
              <div className="col-6 col-lg-3">
                <p className="display-size-3 font-untitled-bold m-0 color-white">
                  30+
                </p>
                <p className="display-size-13 display-size-13-sm font-slatepro-medium m-0 color-white">
                  PRODUCTS OFFERED GLOBALLY
                </p>
              </div>
              <div className="col-6 col-lg-3">
                <p className="display-size-3 font-untitled-bold m-0 color-white">
                  10x
                </p>
                <p className="display-size-13 display-size-13-sm font-slatepro-medium m-0 color-white">
                  VOTED BEST FIXED INCOME PLATFORM
                </p>
                <p className="display-size-13 display-size-13-sm mt-2 mb-0">
                  by Financial News
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Progess;
